import { createSlice } from '@reduxjs/toolkit';

import { loadSupportRequest } from '../thunks/supportRequest.thunk';

export interface ISupportRequestState {
  requiresSupport?: boolean;
  isLoading: boolean;
  error: string | null;
}

const initialState: ISupportRequestState = {
  requiresSupport: undefined,
  isLoading: false,
  error: null,
};

export const supportRequestSlice = createSlice({
  name: 'supportRequest',
  initialState,
  reducers: {
    setRequiresSupport: (state, action) => {
      state.requiresSupport = action.payload;
    },
    resetSupportRequest: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(loadSupportRequest.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });

    builder.addCase(loadSupportRequest.fulfilled, (state, action) => {
      state.isLoading = false;
      state.error = null;
      state.requiresSupport = action.payload;
    });

    builder.addCase(loadSupportRequest.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error as string;
      state.requiresSupport = false;
    });
  },
});

export const { setRequiresSupport, resetSupportRequest } = supportRequestSlice.actions;
